import * as types from './types';

export const state = {
  userPhoto: '',
};

export const mutations = {
  [types.SET_USER_PHOTO](state, userPhoto) {
    state.userPhoto = userPhoto;
  },
  [types.CLEAR_USER_PHOTO](state) {
    state.userPhoto = '';
  },
};



// WEBPACK FOOTER //
// ./src/screens/Profile/store/mutations.js